import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Business } from './business.entity'

export class BusinessRepository extends BaseRepository<Business> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.prospectApiUrl + '/business', token, cache)
    }
}
